import { NavSecondLevelButton, NavSecondLevelMenu, NavSecondLevelTag, NavThirdLevelButton } from 'bimui';
import { ReactComponent as MatSvg } from 'bimui/dist/c1/icons/material.svg';
import { ReactComponent as SecSvg } from 'bimui/dist/c1/icons/section.svg';
import { ReactComponent as ConstructSvg } from 'bimui/dist/c1/icons/construction.svg';
import { ReactComponent as SettingSvg } from 'bimui/dist/c1/icons/settings.svg';
import { ReactComponent as ExportSvg } from 'bimui/dist/c1/icons/export.svg';
import { ReactComponent as HelpSvg } from 'bimui/dist/c1/icons/help.svg';
import { ReactComponent as FastGenerationSvg } from 'bimui/dist/c1/icons/fast-generation.svg';
import { ReactComponent as PlaceholderSvg } from 'bimui/dist/c1/icons/placeholder.svg';
import { EngineContext, NavigationContext, PositionContext, RegisterContext } from '@/App';
import { useContext, useEffect, useState } from 'react';
import { RegisterStatus } from '@/store/register-store';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as UserSvg } from 'bimui/dist/c1/icons/user-2.svg';
import { ReactComponent as DocumentSvg } from 'bimui/dist/c1/icons/document.svg';
import classNames from 'classnames';
import { SIDEBAR_TYPE, TOOL_TYPE } from '@/declare/enums/menu-type';

/**
 * 项目模块的按钮
 */
export default function ProjectMenu() {
    const { projectUuid } = useParams();
    const navigate = useNavigate();

    const registerContext = useContext<RegisterStatus>(RegisterContext);
    const navigateContext = useContext(NavigationContext);
    const registContext = useContext(RegisterContext);
    const engineContext = useContext(EngineContext); // 获取上下文
    const [selectedMajor, setSelectedMajor] = useState<string>(); // 被选择的专业
    const positionContext = useContext(PositionContext);

    useEffect(() => {
        setSelectedMajor(registerContext.libMenus.length > 0 ? registerContext.libMenus[0].pluginUuid : null)
    }, [])

    // 切换专业库
    const onChangeMajorLib = (value) => {
        setSelectedMajor(value);
    }

    const onNavigateToAxisNet = () => {
        if (!projectUuid || projectUuid == "undefined") return;
        navigate(`/projects/${projectUuid}/axis-net`)
    }

    return (
        <>
            <NavSecondLevelTag wrapClassName={classNames({
                "selected": [SIDEBAR_TYPE.USER, SIDEBAR_TYPE.FILE].includes(registContext.currentActivedSidebarKey)
            })}>管理</NavSecondLevelTag>
            <div className='second-level-nav-group'>
                <NavThirdLevelButton icon={<UserSvg />} active={registerContext.currentActivedSidebarKey === SIDEBAR_TYPE.USER} onClick={() => {
                    registerContext.activeSidebar(SIDEBAR_TYPE.USER)
                    navigate(`/projects/${projectUuid}/users`)
                }}>用户</NavThirdLevelButton>
                <NavThirdLevelButton icon={<DocumentSvg />} active={registerContext.currentActivedSidebarKey === SIDEBAR_TYPE.FILE} onClick={() => {
                    registerContext.activeSidebar(SIDEBAR_TYPE.FILE)
                    navigate(`/projects/${projectUuid}/files`)
                }}>文件</NavThirdLevelButton>
            </div>
            {/* <NavSecondLevelButton wrapClassName={classNames({
                "selected": registerContext.currentActivedSidebarKey === SIDEBAR_TYPE.POSITION
            })} onClick={() => { onNavigateToAxisNet(); registerContext.activeSidebar(SIDEBAR_TYPE.POSITION) }}>定位</NavSecondLevelButton>
            <div className='second-level-nav-group'>
                <NavThirdLevelButton icon={<FastGenerationSvg />} active={registerContext.currentActivedSidebarKey === SIDEBAR_TYPE.POSITION && positionContext.fastGenVisible} onClick={() => {
                    onNavigateToAxisNet();
                    registerContext.activeSidebar(SIDEBAR_TYPE.POSITION);
                    positionContext.setFastGenVisible(!positionContext.fastGenVisible)
                }}>快速生成</NavThirdLevelButton>
            </div> */}
            {/* <NavSecondLevelButton>状态</NavSecondLevelButton>
            <div className='second-level-nav-group'>
                <NavThirdLevelButton icon={<PlaceholderSvg />}>XX</NavThirdLevelButton>
                <NavThirdLevelButton icon={<PlaceholderSvg />}>XX</NavThirdLevelButton>
                <NavThirdLevelButton icon={<PlaceholderSvg />}>XX</NavThirdLevelButton>
            </div> */}
            <NavSecondLevelTag wrapClassName={classNames({
                "selected": [SIDEBAR_TYPE.MATERIAL, SIDEBAR_TYPE.SECTION].includes(registerContext.currentActivedSidebarKey)
            })}>公共库</NavSecondLevelTag>
            <div className='second-level-nav-group'>
                <NavThirdLevelButton icon={<MatSvg />} active={registerContext.currentActivedSidebarKey === SIDEBAR_TYPE.MATERIAL} onClick={() => {
                    navigate(`/projects/${projectUuid}`);
                    registerContext.activeSidebar(SIDEBAR_TYPE.MATERIAL);
                }}>材料</NavThirdLevelButton>
                <NavThirdLevelButton icon={<SecSvg />} active={registerContext.currentActivedSidebarKey === SIDEBAR_TYPE.SECTION}
                    onClick={() => {
                        navigate(`/projects/${projectUuid}`);
                        registerContext.activeSidebar(SIDEBAR_TYPE.SECTION)
                    }}>截面</NavThirdLevelButton>
                <NavThirdLevelButton icon={<ConstructSvg />} >设备</NavThirdLevelButton>
            </div>
            {registContext.libMenus.length > 0 &&
                <>
                    <NavSecondLevelMenu
                        options={registerContext.libMenus.map(item => {
                            return {
                                label: item.title,
                                value: item.pluginUuid,
                            }
                        })}
                        onChange={(value) => {
                            onChangeMajorLib(value)
                        }}
                        value={selectedMajor}
                        wrapClassName={classNames({
                            // "selected": registerContext.libMenus.find(item => item.pluginUuid == selectedMajor)?.subMenuKeys.includes(registerContext.currentActivedSidebarKey)
                            // todo 怎么判断这个 专业库 这个按钮选中
                        })}
                    >{registerContext.libMenus.find(item => item.pluginUuid == selectedMajor)?.title}</NavSecondLevelMenu>
                    {registerContext.libMenus.filter(item => item.pluginUuid == selectedMajor).map(menu =>
                        <menu.menuItem  {...engineContext}
                            currentActivedSidebarKey={registContext.currentActivedSidebarKey}
                            currentActivedToolKey={registerContext.currentActivedToolKey}
                            activeSidebarPanel={(key: string) => {
                                registContext.activeSidebar(key);
                            }} activeToolPanel={(key: string) => {
                                registerContext.activeTool(key);
                            }}
                            coreSidebarType={SIDEBAR_TYPE} coreToolType={TOOL_TYPE}
                        />
                    )}
                </>}
            {/* <div className='second-level-nav-group'>
                <NavThirdLevelButton icon={<CompDefineSvg />} active={registerContext.currentActivedSidebarKey === "structure-component-lib"} onClick={() => registerContext.activeSidebar("structure-component-lib")}>构件</NavThirdLevelButton>
                <NavThirdLevelButton icon={<NodeSvg />}>节点</NavThirdLevelButton>
                <NavThirdLevelButton icon={<PartSvg />}>零部件</NavThirdLevelButton>
            </div>
            <div className='second-level-nav-group'>
                <NavThirdLevelButton icon={<UnitSvg />}>单元</NavThirdLevelButton>
                <NavThirdLevelButton icon={<ConstraintSvg />}>约束</NavThirdLevelButton>
                <NavThirdLevelButton icon={<DefineLoadSvg />}>荷载</NavThirdLevelButton>
            </div>
            <div className='second-level-nav-group'>
                <NavThirdLevelButton icon={<CalculationMethodSvg />} active={registerContext.currentActivedSidebarKey === "param"} onClick={() => registerContext.activeSidebar('param')}>参数</NavThirdLevelButton>
            </div>
                <NavThirdLevelButton icon={<CalculationMethodSvg />}>参数</NavThirdLevelButton>
            </div> */}
            <NavSecondLevelTag>协同</NavSecondLevelTag>
            <div className='second-level-nav-group'>
                <NavThirdLevelButton icon={<PlaceholderSvg />}>变更</NavThirdLevelButton>
                <NavThirdLevelButton icon={<PlaceholderSvg />}>冲突</NavThirdLevelButton>
            </div>
            <NavSecondLevelTag>系统</NavSecondLevelTag>
            <div className='second-level-nav-group'>
                <NavThirdLevelButton icon={<SettingSvg />}>设置</NavThirdLevelButton>
                <NavThirdLevelButton icon={<ExportSvg />}>输出</NavThirdLevelButton>
                <NavThirdLevelButton icon={<HelpSvg />}>帮助</NavThirdLevelButton>
            </div>
        </>
    )
}